const CalendarIcon = ({ size = 24, color = 'currentColor', ...props }) => {
    return (
        <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <path
                d="M4 12V9C4 7.89543 4.89543 7 6 7H18C19.1046 7 20 7.89543 20 9V12M4 12V18C4 19.1046 4.89543 20 6 20H18C19.1046 20 20 19.1046 20 18V12M4 12H20"
                stroke={color}
                strokeWidth="1.5"
                strokeLinejoin="round"
            />
            <path
                d="M16.75 4C16.75 3.58579 16.4142 3.25 16 3.25C15.5858 3.25 15.25 3.58579 15.25 4H16H16.75ZM8.75 4C8.75 3.58579 8.41421 3.25 8 3.25C7.58579 3.25 7.25 3.58579 7.25 4H8H8.75ZM16 7H16.75V4H16H15.25V7H16ZM8 7H8.75V4H8H7.25V7H8Z"
                fill={color}
            />
        </svg>
    )
}

export default CalendarIcon
